import React, { useState } from "react";

function BootstrapModal({
  id,
  title,
  children,
  visible,
  setVisible,
  size,
  ...rest
}) {
  const closeModelHandler = (e) => {
    setVisible(false);
  };
  return (
    <>
      <div
        className={visible ? "modal fade show d-block" : "modal fade d-hidden"}
        id={id}
        tabindex="-1"
        style={{
          backgroundColor: visible ? "rgba(0,0,0,.1)" : "none",
        }}
      >
        <div className={"modal-dialog modal-dialog-centered modal-dialog-scrollable " + size || ""}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                {title}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={closeModelHandler}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BootstrapModal;
